<div class="h-[100vh] overflow-hidden flex flex-col w-full items-center bg-surface-0 p-[10rem]">
    <div class="flex flex-row w-[70rem] h-[35rem]">

        <div class="flex flex-1 flex-col gap-4 p-14 bg-surface-800 text-white items-center rounded-md">
            <h1 class="mt-20 text-5xl font-semibold">Bienvenue !</h1>
            <div class="grow"></div>
            <a href="https://logick.co">
                <img class="w-[8rem]" alt="Logick Logo" src="/img/logick-logo-white.svg" />
            </a>
            <div class="text-2xl font-light">La solution de billetterie au quotidien</div>
        </div>

        <form class="flex flex-1 flex-col gap-6 p-14" [formGroup]="forgotForm" (ngSubmit)="submitForm()">
            <h1 class="text-3xl">Mot de passe oublié</h1>
            <p class="text-surface-500 text-sm">Renseignez votre identifiant pour recevoir un lien de réinitialisation.</p>
            <div class="w-full flex flex-col gap-2">
                <div class="flex flex-col grow">
                    <label for="login">Identifiant</label>
                    <input pInputText id="login" [fluid]="true" formControlName="login" />
                </div>
            </div>
            @if (apiError()) {
                <div class="text-red-500 text-sm">{{ apiError() }}</div>
            }
            <p-button type="submit" label="Envoyer le lien" [fluid]="true" [disabled]="!forgotForm.valid || loading()" [loading]="loading()" />
            <a routerLink="/login" class="underline text-sm">Retour à la connexion</a>
        </form>
    </div>
</div>
